import { EntityModel } from '@/interfaces'
import {
  ALL_CMS_CONFIGS_QUERY,
  CREATE_CMS_CONFIG_MUTATION,
  DELETE_CMS_CONFIG_MUTATION,
  FORCE_DELETE_CMS_CONFIG_MUTATION,
  SINGLE_CMS_CONFIG_QUERY,
  UPDATE_CMS_CONFIG_MUTATION,
} from './graphql'
import cmsContactBlockSettingsEntity from '@/entities/cmsContactBlockSettings/entity'
import cmsSocialMediaSettingsEntity from '@/entities/cmsSocialMediaSettings/entity'
import cmsPageEntity from '@/entities/cmsPage/entity'

const cmsConfigModel: EntityModel = {
  name: 'cmsConfig',
  namePlural: 'cmsConfigs',
  uniqueName: 'cmsConfig',
  uniqueNamePlural: 'cmsConfigs',
  path: 'cms/config/cms_config',
  baseUrl: '/cms/config/cms_configs',
  translationPrefix: 'entities:cmsConfig.',
  getDisplayName: (values: any) => {
    return 'CMS Config'
  },
  gql: {
    getAll: ALL_CMS_CONFIGS_QUERY,
    getSingle: SINGLE_CMS_CONFIG_QUERY,
    create: CREATE_CMS_CONFIG_MUTATION,
    update: UPDATE_CMS_CONFIG_MUTATION,
    delete: DELETE_CMS_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_CMS_CONFIG_MUTATION,
  },
  attributes: {
    contactBlockSettings: {
      name: 'contactBlockSettings',
      label: 'entities:cmsConfig.attributes.contactBlockSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsContactBlockSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    socialMediaSettings: {
      name: 'socialMediaSettings',
      label: 'entities:cmsConfig.attributes.socialMediaSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsSocialMediaSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    privacyPolicyPage: {
      name: 'privacyPolicyPage',
      label: 'entities:cmsConfig.attributes.privacyPolicyPage.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    gtcPage: {
      name: 'gtcPage',
      label: 'entities:cmsConfig.attributes.gtcPage.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsConfigModel
